import {
  ProtocolsPage,
  SitesPage,
  StudyArmsPage,
  StudySchedulerPage,
  ProtocolsNewPage,
  ProtocolsShowPage,
  ContributorRolesPage,
  StudyProcedureTasksPage,
} from './pages';
import ProtocolsEditPage from './pages/ProtocolsEditPage/ProtocolsEditPage';

export default [
  {
    component: ProtocolsPage,
    exact: true,
    name: 'TrialConfigurations',
    path: '/administration/study_protocols',
    subRoutes: [],
  },
  {
    component: ProtocolsNewPage,
    exact: true,
    name: 'TrialConfiguration',
    path: '/administration/study_protocols/new',
  },
  {
    component: ProtocolsShowPage,
    exact: false,
    name: 'TrialConfiguration',
    path: '/administration/study_protocols/:study_protocol_id',
    subRoutes: [
      {
        component: ProtocolsEditPage,
        exact: true,
        name: 'Trial Configuration',
        path: '/administration/study_protocols/:study_protocol_id',
      },
      {
        component: StudyArmsPage,
        exact: true,
        name: 'Study Arms',
        path: '/administration/study_protocols/:study_protocol_id/study_arms',
      },
      {
        component: StudySchedulerPage,
        exact: true,
        name: 'Scheduler',
        path: '/administration/study_protocols/:study_protocol_id/study_scheduler',
      },
      {
        component: ContributorRolesPage,
        exact: true,
        name: 'Contributor Roles',
        path: '/administration/study_protocols/:study_protocol_id/contributor_roles',
      },
      {
        component: StudyProcedureTasksPage,
        exact: true,
        name: 'Tasks',
        path: '/administration/study_protocols/:study_protocol_id/study_procedure_tasks',
      },
      {
        component: SitesPage,
        exact: true,
        name: 'Sites',
        path: '/administration/study_protocols/:study_protocol_id/sites',
      },
    ],
  },
];
